module.exports = __webpack_public_path__ + "img/shopping-cart-duotone.a79cb0e1.svg";